import analytics, {
  EventTypeElementImpression,
  EventTypeElementInteracted,
} from '@nerdwallet/analytics';

export const trackImpression = ({
  entityName,
  sectionName,
  payload,
}: {
  entityName: string;
  sectionName?: string;
  payload?: any;
}) => {
  analytics.track<EventTypeElementImpression>('element_impression', {
    entity_name: entityName,
    section_name: sectionName,
    ...payload,
  });
};

export const trackInteraction = ({
  entityName,
  action,
  sectionName,
}: {
  entityName: string;
  action: EventTypeElementInteracted['Payload']['action'];
  sectionName?: string;
}) => {
  analytics.track<EventTypeElementInteracted>('element_interacted', {
    entity_name: entityName,
    section_name: sectionName,
    action,
    interaction_id: analytics.uuid(),
    interaction_type: 'press',
  });
};
